import WhiteTooltip from "src/components/general/WhiteTooltip/WhiteTooltip";
import { useBuildLink } from "src/hooks/useBuildLink";
import type { ClusterPath } from "src/utils/appRoutes/appRoutes.types";
import { ClusterIcon } from "@ui-icons";
import BreadcrumbLink from "../BreadcrumbLink/BreadcrumbLink";

interface BreadcrumbClusterLinkProps {
  app_name: string;
  cluster_name: string;
}

const BreadcrumbClusterLink = ({
  app_name,
  cluster_name,
}: BreadcrumbClusterLinkProps) => {
  const buildLink = useBuildLink();
  const toUrl = buildLink({
    app_name,
    cluster_name,
    search: window.location.search,
  } as ClusterPath);

  return (
    <BreadcrumbLink
      data-test-id="breadcrumb-cluster"
      to={toUrl}
      startAdornment={ClusterIcon}
      TooltipComponent={WhiteTooltip}
      slotProps={{
        tooltip: {
          force: true,
          enterDelay: 500,
          enterNextDelay: 500,
        },
      }}
    >
      <div className="truncate">{app_name}</div>
    </BreadcrumbLink>
  );
};

export default BreadcrumbClusterLink;
